import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enUSLang from './lang/en-US';

Vue.use(VueI18n);
// 一次性引入所有的语言包,可能问题导致 打包过大，首屏慢
// import langMap from '../constant/i18n';
// const lang = langMap.map(item => item.value);
// const i18n = new VueI18n({
// 	locale: 'en-US',
// 	messages: lang.reduce((pre, next) => {
// 		pre[next] = require(`./lang/${next}.json`);
// 		return pre;
// 	}, {}),
// });
// 首次只载入默认的语言包
// 在切换语言时动态加载语言包（按需）

const defaultLang = process.env.VUE_APP_DEFAULT_LANG;
const i18n = new VueI18n( {
	locale: defaultLang,
	messages: {
		[defaultLang]:enUSLang
	}
});

export default i18n;
